import request from '@/utils/request'

// 查询列表-物料类别
export function apiItemCategorySetList (query) {
  return request({
    url: '/mdm/itemCategorySet/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiMdmItemCategorySetNewExport (data) {
  return request({
    url: '/mdm/itemCategorySet/v2/export',
    method: 'post',
    data: data
  })
}

// 类别集名称-物料类别
export function apiItemCategorySetPullDownList (query) {
  return request({
    url: '/mdm/itemCategorySet/pullDownList',
    method: 'get',
    params: query
  })
}

// 新增-类别代码
export function apiItemCategoryCodeAdd (data) {
  return request({
    url: '/mdm/itemCategoryCode/add',
    method: 'post',
    data: data
  })
}

// 修改-物料类别
export function apiItemCategorySetEdit (data) {
  return request({
    url: '/mdm/itemCategorySet/edit',
    method: 'put',
    data: data
  })
}

// 修改-类别代码
export function apiItemCategoryCodeEdit (data) {
  return request({
    url: '/mdm/itemCategoryCode/edit',
    method: 'put',
    data: data
  })
}

// 查询列表-类别代码
export function apiItemCategoryCodeList (query) {
  return request({
    url: '/mdm/itemCategoryCode/list',
    method: 'get',
    params: query
  })
}

// 查询列表-物料类别分配
export function apiItemApportionList (query) {
  return request({
    url: '/mdm/itemApportion/list',
    method: 'get',
    params: query
  })
}

// 新增-物料类别分配
export function apiItemApportionAdd (data) {
  return request({
    url: '/mdm/itemApportion/add',
    method: 'post',
    data: data
  })
}

// 修改-物料类别分配
export function apiItemApportionEdit (data) {
  return request({
    url: '/mdm/itemApportion/edit',
    method: 'put',
    data: data
  })
}

// 删除-物料类别分配
export function apiItemApportionDelete (dictId) {
  return request({
    url: `/mdm/itemApportion/${dictId}`,
    method: 'delete'
  })
}

// 类别说明
export function apiItemCategoryCodePullDownList (query) {
  return request({
    url: '/mdm/itemCategoryCode/pullDownList',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiMdmItemApportionNewExport (data) {
  return request({
    url: '/mdm/itemApportion/v2/export',
    method: 'post',
    data: data
  })
}

// 物料类别-新增
export function apiItemCategorySetAdd (data) {
  return request({
    url: '/mdm/itemCategorySet/add',
    method: 'post',
    data: data
  })
}
